import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";

import { Currency, PaymentGateways } from "../types";
import { axiosQuery } from "../utils/axiosHelpers";

const APP_URL = import.meta.env.VITE_URL;

interface GetPaymentGatewaysResponse {
  paymentGateways: PaymentGateways;
}

const QUERY = gql`
  query GetPaymentGateways(
    $host: String!
    $country: String!
    $currency: String
  ) {
    paymentGateways(host: $host, country: $country, currency: $currency) {
      creditCardGatewayName
      hostedPageId
      paypalGatewayName
    }
  }
`;

export const useGetPaymentGateways = (country: string, currency: Currency) =>
  useQuery<PaymentGateways>({
    queryKey: ["getPaymentGateways", country, currency],
    queryFn: async () => {
      const response = await axiosQuery<GetPaymentGatewaysResponse>(
        "GetPaymentGateways",
        QUERY,
        {
          host: new URL(APP_URL).host,
          country,
          currency,
        },
      );
      return response.paymentGateways;
    },
    staleTime: Infinity,
  });
